export function easeOutExpo(x: number): number {
  return x === 1 ? 1 : 1 - 2 ** (-10 * x)
}

export function easeInExpo(x: number): number {
  return x === 0 ? 0 : 2 ** (10 * x - 10)
}

export function easeOutQuart(x: number): number {
  return 1 - (1 - x) ** 4
}

export function easeOutQuad(x: number): number {
  return 1 - (1 - x) * (1 - x)
}

export function easeInOutQuart(x: number): number {
  return x < 0.5 ? 8 * x * x * x * x : 1 - (-2 * x + 2) ** 4 / 2
}
